import { netWorth, occupationOf, OCCUPATION_LABEL, OCCUPATION_ESTIMATED, WORK_START_AGE } from '../lib/economy.js';

// 만원 단위 금액을 읽기 쉬운 문장으로 (예: 12345 → 1억 2,345만원)
export const manwon = (v) => {
  const n = Math.round(v), abs = Math.abs(n), sign = n < 0 ? '-' : '';
  if (abs >= 10000) { const eok = Math.floor(abs / 10000), rest = abs % 10000; return `${sign}${eok}억${rest ? ` ${rest.toLocaleString()}만원` : '원'}`; }
  return `${sign}${abs.toLocaleString()}만원`;
};

const MARRIAGE = { single: '미혼', married: '기혼', divorced: '이혼' };

/** 가족·반려동물·집·건강과 소득·자산을 보여 준다. 인생 사건을 켠 새 진행(s.life)에만 나온다. */
export default function LifeCard({ s }) {
  const life = s.life;
  if (!life) return null;
  const e = life.economy, occ = occupationOf(s.job);
  const kids = life.children?.length ?? 0;
  const marriage = life.marriage ?? {};
  const active = e && s.age >= WORK_START_AGE;
  return (
    <section className="panel life-card">
      <h3>나의 생활</h3>
      <dl className="life-facts">
        <div><dt>가족</dt><dd>{MARRIAGE[marriage.status] ?? '미혼'}{marriage.at != null && marriage.status !== 'single' ? ` (${marriage.at}세)` : ''} · 자녀 {kids}명</dd></div>
        <div><dt>반려동물</dt><dd>{(life.pet?.count ?? (life.pet?.owned ? 1 : 0)) > 0 ? `${life.pet?.count ?? 1}마리${life.pet.since != null ? ` (${life.pet.since}세부터)` : ''}` : '없음'}</dd></div>
        <div><dt>집</dt><dd>{life.home?.count ? `${life.home.count}채 보유` : '없음'}</dd></div>
        <div><dt>건강</dt><dd>{life.health?.state === 1 ? '병원비 부담이 이어지는 중' : '큰 문제 없음'}</dd></div>
        {occ && <div><dt>직종</dt><dd>{OCCUPATION_LABEL[occ]}{OCCUPATION_ESTIMATED.has(s.job?.id) ? ' (임금표에 없어 가까운 직종으로 계산)' : ''}</dd></div>}
      </dl>
      {active ? (
        <dl className="life-facts life-money">
          <div><dt>연 소득(가구)</dt><dd>{manwon(e.income)}</dd></div>
          <div><dt>총자산</dt><dd>{manwon(Math.max(0, e.cash) + e.homeValue)}</dd></div>
          <div className="life-sub"><dt>ㄴ 현금</dt><dd>{manwon(e.cash)}</dd></div>
          <div className="life-sub"><dt>ㄴ 집 가치</dt><dd>{e.homeValue > 0 ? manwon(e.homeValue) : '없음'}</dd></div>
          <div><dt>부채</dt><dd>{manwon(e.mortgage + e.other)}</dd></div>
          <div><dt>순자산 (총자산 − 부채)</dt><dd><b>{manwon(netWorth(e))}</b></dd></div>
        </dl>
      ) : <p className="life-explanation">소득과 자산은 {WORK_START_AGE}세부터 계산합니다.</p>}
      <p className="life-explanation">금액은 2025년 통계에 그해 물가를 반영한 값이며 가구(본인·배우자·자녀) 단위로 계산합니다.</p>
    </section>
  );
}
